import Serializer from 'umg-ember-backend/serializers/application';

export default class SectionSerializer extends Serializer {
  attrs = {
    belonging: 'belongsTo',
  };
}
